import React, { MouseEvent as ReactMouseEvent } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import ArrowIcon from 'Assets/images/icons/select-arrow-icon.svg';

interface ArrowButtonProps {
  onClick?: (event: ReactMouseEvent<HTMLDivElement, MouseEvent>) => void;
  orientation: 'left' | 'right';
}

const ArrowButton = (props: ArrowButtonProps) => {
  const { onClick, orientation } = props;

  return (
    <div
      onClick={onClick}
      className={classNames('slider__button', {
        'slider__button--next': orientation === 'right',
        'slider__button--prev': orientation === 'left',
      })}
    >
      <ReactSVG src={ArrowIcon} />
    </div>
  );
};

export default ArrowButton;
